export const getAlertObservation = ({
  alerts = [],
  rules = [],
  resources = [],
  health = null,
  alertsError = false,
  rulesError = false,
  resourcesError = false,
  healthError = false,
} = {}) => {
  const activeAlerts = alerts.filter((alert) => ['open', 'acknowledged'].includes(alert.status));
  const enabledRules = rules.filter((rule) => rule.enabled);
  const unknownResources = resources.filter((resource) => resource.status === 'unknown').length;
  const staleResources = resources.filter((resource) => resource.stale === true).length;
  const degradedResources = Number(health?.degraded ?? health?.error ?? 0);

  if (alertsError) {
    return {
      tone: 'danger',
      title: 'Alert state unavailable',
      detail: 'Cloud Watcher could not load active alerts, so it cannot make a health assessment.',
      activeAlerts,
      enabledRules,
      unknownResources,
      staleResources,
      degradedResources,
    };
  }

  if (healthError || resourcesError) {
    return {
      tone: 'danger',
      title: 'System health unavailable',
      detail: 'One or more health inputs failed to load. Existing alert results are incomplete.',
      activeAlerts,
      enabledRules,
      unknownResources,
      staleResources,
      degradedResources,
    };
  }

  if (activeAlerts.length || unknownResources || staleResources || degradedResources) {
    const evidence = [
      activeAlerts.length && `${activeAlerts.length} active alert${activeAlerts.length === 1 ? '' : 's'}`,
      degradedResources && `${degradedResources} degraded resource${degradedResources === 1 ? '' : 's'}`,
      unknownResources && `${unknownResources} resource${unknownResources === 1 ? '' : 's'} in an unknown state`,
      staleResources && `${staleResources} stale inventory record${staleResources === 1 ? '' : 's'}`,
    ].filter(Boolean);
    return {
      tone: 'warning',
      title: 'Infrastructure needs attention',
      detail: evidence.join(' · '),
      activeAlerts,
      enabledRules,
      unknownResources,
      staleResources,
      degradedResources,
    };
  }

  if (rulesError) {
    return {
      tone: 'warning',
      title: 'Monitoring configuration unavailable',
      detail: 'Alert results loaded, but Cloud Watcher could not verify which monitoring rules are enabled.',
      activeAlerts,
      enabledRules,
      unknownResources,
      staleResources,
      degradedResources,
    };
  }

  if (enabledRules.length === 0) {
    return {
      tone: 'neutral',
      title: 'Monitoring is not configured',
      detail: 'No enabled alert rules are observing resources. Zero alerts is not a health confirmation.',
      activeAlerts,
      enabledRules,
      unknownResources,
      staleResources,
      degradedResources,
    };
  }

  return {
    tone: 'neutral',
    title: 'No active alerts observed',
    detail: `${enabledRules.length} enabled rule${enabledRules.length === 1 ? '' : 's'} returned no active alerts. This is an observation, not a guarantee of health.`,
    activeAlerts,
    enabledRules,
    unknownResources,
    staleResources,
    degradedResources,
  };
};
